import React, { useEffect, useState } from 'react';
import styles from './procedimentos_beatriz_martinsstudio.module.scss';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const AGENDA_URL = 'https://client.tuaagenda.com/c/BeatrizMartins5';

const procedimentos = [
    {
        titulo: 'Brow lamination',
        descricao:
            'Técnica que alinha, preenche e modela os fios da sobrancelha, garantindo um efeito mais cheio, definido e natural por mais tempo.',
        imagens: [require('./src/procedimento_1_1.png'), require('./src/procedimento_1_2.png')] as string[],
    },
    {
        titulo: 'Micropigmentação labial',
        descricao:
            'Procedimento que realça o contorno e a cor dos lábios, corrigindo assimetrias e proporcionando um aspecto saudável e uniforme.',
        imagens: [require('./src/procedimento_2_1.png'), require('./src/procedimento_2_2.png')] as string[],
    },
    {
        titulo: 'Dermaplaning',
        descricao:
            'Esfoliação física que remove células mortas e penugens do rosto, deixando a pele mais lisa, iluminada e pronta para absorver melhor os cosméticos.',
        imagens: [require('./src/procedimento_3_1.png')] as string[],
    },
    {
        titulo: 'Ombre shadow',
        descricao:
            'Técnica de micropigmentação de sobrancelhas que cria um degradê suave, mais marcado na cauda e delicado na frente, com efeito de sombra.',
        imagens: [require('./src/procedimento_4_1.png')] as string[],
    },
    {
        titulo: 'Microblading fio a fio',
        descricao:
            'Micropigmentação feita fio a fio que imita pelos naturais, ideal para preencher falhas e dar mais definição às sobrancelhas.',
        imagens: [require('./src/procedimento_5_1.png')] as string[],
    },
    {
        titulo: 'Hidra gloss lips',
        descricao:
            'Tratamento labial que combina esfoliação e hidratação profunda, devolvendo viço, maciez e brilho natural aos lábios.',
        imagens: [require('./src/procedimento_6_1.png')] as string[],
    },
    {
        titulo: 'Hidra gloss color',
        descricao:
            'Versão com cor do Hidra gloss, que além de hidratar intensamente, deposita um tom suave para realçar os lábios de forma natural.',
        imagens: [require('./src/procedimento_7_1.png')] as string[],
    },
    {
        titulo: 'Lash lifting',
        descricao:
            'Alongamento e curvatura dos cílios naturais sem uso de extensões, valorizando o olhar com efeito de cílios mais longos e levantados.',
        imagens: [require('./src/procedimento_8_1.png'), require('./src/procedimento_8_2.png')] as string[],
    },
    {
        titulo: 'Micropigmentação labial em lábios negros',
        descricao:
            'Técnica específica para lábios mais escuros, que ajuda a neutralizar tons acinzentados ou arroxeados antes de receber a cor desejada.',
        imagens: [require('./src/procedimento_9_1.png'), require('./src/procedimento_9_2.png')] as string[],
    },
    {
        titulo: 'Design com aplicação de henna',
        descricao:
            'Modelagem das sobrancelhas com marcação precisa e aplicação de henna para realçar o desenho e preencher falhas temporariamente.',
        imagens: [require('./src/procedimento_10_1.png')] as string[],
    },
    {
        titulo: 'Design simples',
        descricao:
            'Design de sobrancelhas feito apenas com remoção e alinhamento dos fios, respeitando o formato natural do rosto.',
        imagens: [require('./src/procedimento_11_1.png')] as string[],
    },
];

interface CardProcedimentoProps {
    titulo: string;
    descricao: string;
    imagens: string[];
}

const CardProcedimento: React.FC<CardProcedimentoProps> = ({
    titulo,
    descricao,
    imagens,
}) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const hasImages = imagens.length > 0;
    const hasMultipleImages = imagens.length > 1;

    const prevImage = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (!hasMultipleImages) return;
        setCurrentIndex((prev) => (prev === 0 ? imagens.length - 1 : prev - 1));
    };

    const nextImage = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (!hasMultipleImages) return;
        setCurrentIndex((prev) => (prev === imagens.length - 1 ? 0 : prev + 1));
    };

    const handleAgendamentoClick = () => {
        window.open(AGENDA_URL, '_blank', 'noopener,noreferrer');
    };

    return (
        <div className={styles.card}>
            <div className={styles.carouselContainer}>
                {hasImages ? (
                    <>
                        <img src={imagens[currentIndex]} alt={titulo} />
                        {hasMultipleImages && (
                            <>
                                <button
                                    type="button"
                                    className={`${styles.carouselBtn} ${styles.prevBtn}`}
                                    onClick={prevImage}
                                    aria-label="Imagem anterior"
                                >
                                    <FaChevronLeft />
                                </button>
                                <button
                                    type="button"
                                    className={`${styles.carouselBtn} ${styles.nextBtn}`}
                                    onClick={nextImage}
                                    aria-label="Próxima imagem"
                                >
                                    <FaChevronRight />
                                </button>
                                <div className={styles.indicators}>
                                    {imagens.map((_, idx) => (
                                        <span
                                            key={idx}
                                            role="button"
                                            tabIndex={0}
                                            className={`${styles.dot} ${idx === currentIndex ? styles.active : ''}`}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setCurrentIndex(idx);
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter' || e.key === ' ') {
                                                    e.preventDefault();
                                                    setCurrentIndex(idx);
                                                }
                                            }}
                                            aria-label={`Ir para imagem ${idx + 1}`}
                                        />
                                    ))}
                                </div>
                            </>
                        )}
                    </>
                ) : (
                    <div className={styles.placeholderImagem}>
                        <span>Imagens em breve</span>
                    </div>
                )}
            </div>
            <h3>{titulo}</h3>
            {descricao ? <p className={styles.descricao}>{descricao}</p> : null}
            <button
                type="button"
                className={styles.agendamentoBtn}
                onClick={handleAgendamentoClick}
            >
                Faça seu agendamento
            </button>
        </div>
    );
};

const Procedimentos_beatriz_martinsstudio: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.pageWrapper}>
            <div className={styles.procedimentos_beatriz_martinsstudio}>
                <div className={styles.header}>
                    <Link to="/beatriz_martinsstudio" className={styles.backButton} aria-label="Voltar">
                        <FaArrowLeft />
                    </Link>
                    <h2>Procedimentos</h2>
                </div>
                <div className={styles.lista}>
                    {procedimentos.map((item, index) => (
                        <CardProcedimento
                            key={index}
                            titulo={item.titulo}
                            descricao={item.descricao}
                            imagens={item.imagens}
                        />
                    ))}
                </div>
            </div>
            <div className={styles.footer}>
                <img
                    src={require('./src/logo.png')}
                    alt="Beatriz Martins Studio"
                    className={styles.footerLogo}
                />
            </div>
        </div>
    );
};

export default Procedimentos_beatriz_martinsstudio;
